<template>
    <HpoPatientModalSection :title="pgettext('label', 'Gender')">
        <template v-slot:summary>
            {{ GenderLabel[modelValue] }}
        </template>

        <template v-slot:body>
            <div class="phc-buttons-row priority-buttons">
                <SelectButton :value="Gender.MALE"
                              v-model="gender">
                    {{ GenderLabel[Gender.MALE] }}
                </SelectButton>
                <SelectButton :value="Gender.FEMALE"
                              v-model="gender">
                    {{ GenderLabel[Gender.FEMALE] }}
                </SelectButton>
            </div>
        </template>
    </HpoPatientModalSection>
</template>

<script setup>
import HpoPatientModalSection from "../../HpoPatientModalSection.vue";
import SelectButton from "../../SelectButton.vue"
import {computed} from "vue"
import {Gender, GenderLabel} from "../../../../../choices";


const props = defineProps({
    modelValue: {
        type: String,
        required: false,
        default: null,
    }
})

const emit = defineEmits('update:modelValue')

const gender = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
});
</script>

